import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';


export default function QrScanResult( props ) {
    //console.debug("RTS Break QrScanResult");

    const theme = useTheme();

    const {setCurFilter, user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const history = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    const [showNotFoundModal, setShowNotFoundModal] = useState(false);

    const [trackerIdSeq, setTrackerIdSeq] = useState('');
    const [trackerFound, setTrackerFound] = useState(false);
    const [reelSerial, setReelSerial] = useState('');
    const [reel, setReel] = useState(null);
    const [reelFound, setReelFound] = useState(false);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/LoadList/GetLoadByTrackerIdSeq";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if(response.status === 200){
                setTrackerFound(true);
                setTrackerIdSeq(response.data.tracker.idSeq);

                if(response.data.reel != null){
                    setReelFound(true);
                    setReel(response.data.reel);
                    setReelSerial(response.data.reel.serialNumber);
                }
            }
            else{
                setTrackerFound(false);
                setTrackerIdSeq('');
                setReelFound(false);
                setReel(null);
                setReelSerial('');
                setShowNotFoundModal(true);
            }
            setIsLoading(false);
        })
        .catch(error => {
            setIsLoading(false);
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]); 


    useEffect(() => {
        fetchData({customerIdGuid:sessionCustomer.customer.idGuid, idSeq:props.qrSerial});
    }, [props.qrSerial]);


    function handleSubmit(e) {
        e.preventDefault();

        setCurFilter({key:'LoadListPage', filter:{User:user, 
            Status:[],
            Customer:sessionCustomer.customer,
            Orders:[], 
            Projects:[], 
            Products:[], 
            ReelTypes:[],
            Reels:[reel],
            LenghtOperator:">=",
            Length:0,
            NamedLocations:[],
            Crews:[],
            Trackers:[],
            ShipDateOperator:">=",
            ShipDate:null,
            Pinned:-1,
            Locked:-1,
            DaysStationaryOperator:">=",
            DaysStationary:0,
            SortBy:0}
        });        
    
        history("/LoadList", {state:{}});
    } 


    function onClearClicked(e){
        setTrackerIdSeq('');
        setTrackerFound(false);
        setReelSerial('');
        setReel(null);
        setReelFound(false);
        props.setQrFoundFx(false);
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
        <Dialog fullWidth={true} maxWidth="sm" open={showNotFoundModal}>
            <DialogTitle>Tracker Not Found</DialogTitle>
            <DialogContent>
                <Typography>A QR Code was detected but the reel associated with this QR Code was not found for this customer.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowNotFoundModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Container maxWidth="xs">
            <Box sx={{marginTop: 2}}>
                <form id="qrScanForm" onSubmit={handleSubmit}>
                    <TextField
                        id="tbIdTracker"
                        margin="normal"
                        fullWidth
                        label="Tracker Id"
                        size="small"
                        value={trackerIdSeq}
                        onChange={(e) => {setTrackerIdSeq(e.target.value);}}
                        disabled
                    />
                    {
                        trackerFound===true
                        ?
                        <Typography sx={{color:'green'}}>Tracker Found</Typography>
                        :
                        <Typography sx={{color:'red'}}>Tracker Not Found</Typography>
                    }

                    <TextField
                        id="tbIdReel"
                        margin="normal"
                        fullWidth
                        label="Reel"
                        size="small"
                        value={reelSerial}
                        onChange={(e) => {setReelSerial(e.target.value);}}
                        disabled
                    />
                    {
                        reelFound===true
                        ?
                        <Typography sx={{color:'green'}}>Reel Found</Typography>
                        :
                        <Typography sx={{color:'red'}}>Reel Not Found</Typography>
                    }                                        

                    <Box sx={{textAlign:'center', mt:3}}>
                        <Button variant="contained"  type="submit" sx={{mr:2}} disabled={!reelFound} >
                            Show Reel
                        </Button>
                        <Button variant="contained"  type="button" onClick={onClearClicked} >
                            Re-Scan
                        </Button>                   
                    </Box>                
                </form>
            </Box>
        </Container>
        </>
    );
}
